import { useState } from "react";
import { Key_enrollments, PAGE_NUMBER, PAGE_SIZE, processModelName_renewEnrollmentByStudent } from "../../utils/constants";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { useMutation, useQueryClient } from "react-query";
import { useGetTeacheIdByUserId } from "../../hooks/useGetTeacheIdByUserId";
import { useGetEnrollmentsByStudentQuery } from "../../hooks/useGetSubscriptionsByStudentQuery";
import { Badge, Callout, Flex, Text } from "@radix-ui/themes";
import { routes } from "../../routes";
import TableComponent from "../../components/common/Tables";
import { Lists } from "../../components/common/Lists";
import { setLoaderAvailable } from "../../redux/slices/loaderController";
import { getStudentById } from "../../services/school/student/getStudentByCode";
import { createEnrollment, createEnrollmentByStudent } from "../../services/school/student/createEnrollment";
import { useGetCurrentAcademicYearQuery } from "../../hooks/useGetCurrentAcademicYearQuery";
import toast from "react-hot-toast";
import { useLogoBase64 } from "../../hooks/useLogoBase64";
import { useIES } from "../../hooks/useIES";
import { useExportDocument } from "../../hooks/useExportDocument";
import { createStudentDebt, getStudentDebtsByEnrollment } from "../../services/finance/studentDebt";
import { isEmpty } from "lodash";
import { useGetProcessModelsQuery } from "../../hooks/useGetProcessModelsQuery";
import { getProcessModels } from "../../services/finance/processModels";
import { useGetPaymentTypesQuery } from "../../hooks/useGetPaymentTypesQuery";
import { PaymentReferenceType, StudentDebtType } from "../../types/Finance";
import { addDays, addDaysToDate, formatDateForInput } from "../../utils/dateFormatter";
import { useGetSchoolBankConfigQuery } from "../../hooks/useGetSchoolBankConfigQuery";
import { createPaymentReference, getReferenceCodeV2 } from "../../services/finance/paymentReference";
import { RootState } from "../../redux/store";
import { useSelector } from "react-redux";



const columnNamesMap: { [key: string]: string } = {
    fullname: 'Estudante',
    student: 'Código',
    course: 'Curso',
    academicYear: 'Ano lectivo',
    isValidatedIcon: 'Válida',
};

export const RenewMyEnrollment = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { UserId } = useAppSelector((state) => state.login.userData)
    const { data: studentData } = useGetTeacheIdByUserId(UserId, { enabled: !!UserId });
    const { data, status } = useGetEnrollmentsByStudentQuery({ PageNumber: currentPage, PageSize: pageSize, SearchTerm: searchTerm, IdStudent: studentData?.idStudent },
        { enabled: !!studentData?.idStudent }

    );
    const { exportDocumentPdf: exportDocument, downloadOnly } = useExportDocument();
    const { data: paymentTypesData, status: paymentTypesStatus, isError: isErrorPaymentTypes, isLoading: isLoadingPaymentTypes } = useGetPaymentTypesQuery({ PageNumber: 1, PageSize: 400 });
    const mutationCreateStudentDebt = useMutation({ mutationFn: createStudentDebt, mutationKey: 'createStudentDebt' });
    const { data: schoolBankConfigsData, status: schoolBankConfigsStatus, isError: isErrorSchoolschoolBankConfigs, isLoading: isLoadingSchoolschoolBankConfigs } = useGetSchoolBankConfigQuery({ PageNumber: 1, PageSize: 400 });

    const loginData = useAppSelector((state) => state.login.userData);
    const { logoBase64 } = useLogoBase64();
    const { IES } = useIES();
    const userData = useSelector((state: RootState) => state.login.userData)

    const mutationCreateEnrollment = useMutation({
        mutationFn: createEnrollmentByStudent,
        mutationKey: "createEnrollmentByStudent",
    });
    const { data: currentYear } = useGetCurrentAcademicYearQuery();
    const mutationSaveReferenceCode = useMutation({ mutationFn: createPaymentReference, mutationKey: 'createPaymentReference' });

    const options = data?.items.map(() => [

    ]) || [];

    if (!studentData || !studentData.idStudent) {
        return (
            <Flex direction="column">
                <Callout.Root color="red" role="alert">
                    <Text>
                        Entre como estudante &nbsp;
                        <Link to={routes.dashboard} style={{ color: 'var(--gray-12)' }}>Voltar</Link>
                    </Text>
                </Callout.Root>

            </Flex>
        );
    }
    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handlePageSizeChange = (size: number) => {
        setPageSize(size);
        setCurrentPage(PAGE_NUMBER);
    };

    const handleSearch = (term: string) => {
        setSearchTerm(term);
        setCurrentPage(1);
    };

    const handleClickCreate = async (event: any) => {

        try {
            dispatch(setLoaderAvailable(true));
            const _studentData = await getStudentById(studentData?.idStudent);
            const resultCreateEnrollment = await mutationCreateEnrollment.mutateAsync(
                {
                    idCourse: _studentData.idCourse!,
                    idAcademicYear: currentYear?.id,
                    idStudent: studentData?.idStudent,
                    regime: _studentData.regime,
                    subscribeStudent: false,
                    idPlan: _studentData.idPlan!,
                }
            );
            if (!resultCreateEnrollment) return;

            const processModelsData = await getProcessModels({
                ProcessName: processModelName_renewEnrollmentByStudent,
                PageNumber: 1,
                PageSize: 1,
                CourseLevel: _studentData?.courseLevel ?? "",
                CourseModality: _studentData?.modality ?? "",
            });
            if (processModelsData?.items?.length === 0) {
                toast.custom(
                    "Não foi possível encontrar o modelo de processo para renovação de matrícula. Logo não é possível gerar a referencia."
                ,{
                    icon: '⚠️',
                    id: `process-model-not-found${new Date().toLocaleDateString()}`,
                
                });
            }

            const processModel = processModelsData?.items?.at(0);
            const { id, amount, } = paymentTypesData?.items?.filter(i => Number((i?.internalCode!)) === 25 && processModelsData?.items.at(0)?.idsPaymentTypes?.includes(i.id ?? "")).at(0) || {};

            toast.success("Matrícula renovada!");
            queryClient.invalidateQueries({ queryKey: [Key_enrollments] });

            let payment = {
                isPaymentByEntityReference: false,
                entity: processModel?.idSchoolBankConfig,
                reference: '',
                totalPrice: amount || 0,
                paymentProof: '',
                idStudentDebt: '',
                bankName: ''
            };
            let isExistStudentDebt = true;
            try {
                const studentDebtsResponse = await getStudentDebtsByEnrollment(resultCreateEnrollment) as StudentDebtType[];
                const studentDebtData = studentDebtsResponse?.[0];
                if (!studentDebtData) throw new Error('No student debt data found');
                const paymentReferences = studentDebtData?.paymentReferences;
                const paymentTransactions = studentDebtData?.paymentTransactions;
                const paymentTransaction = paymentTransactions?.find(p => p?.status);
                const paymentReference = paymentReferences?.find(p => p?.status);
                payment = {
                    entity: paymentReference?.entity ?? "",
                    reference: paymentReference?.referenceCode ?? "",
                    totalPrice: paymentReference?.amount ?? 0,
                    paymentProof: paymentTransaction?.paymentProof,
                    idStudentDebt: studentDebtData?.id ?? "",
                    isPaymentByEntityReference: isEmpty(paymentReference?.referenceCode) ? false : true,
                    bankName: String(schoolBankConfigsData?.items.find(i => i.id === processModel?.idSchoolBankConfig)?.bankName || ''),
                }
            } catch (error) {
                console.log("No existing student debt found, creating a new one.");
                isExistStudentDebt = false;
            }
            if (!isExistStudentDebt) {
                // create a new student debt here and get the payment info
                if (processModel && processModel?.id) {
                    let studentDebtData: StudentDebtType = {
                        idStudent: studentData?.idStudent!,
                        idPaymentType: id!,
                        originalAmount: amount!,
                        currentAmount: amount!,
                        dueDate: formatDateForInput(addDaysToDate(new Date(), 30).toISOString()),
                        description: `Débito referente à ${processModelName_renewEnrollmentByStudent.replace(/_/g, ' ')}`,
                        status: true,
                        isPayed: false,
                        fullname: _studentData?.fullname!,
                        idEnrollment: resultCreateEnrollment!,
                        generateRef: true,
                    };
                    const currentDate = new Date();

                    const resultCreateStudentDebt = await mutationCreateStudentDebt.mutateAsync(studentDebtData);
                    studentDebtData = { ...studentDebtData, id: resultCreateStudentDebt };
                    const referenceCode = await getReferenceCodeV2({
                        amount: studentDebtData.currentAmount,
                        idStudent: studentDebtData.idStudent,
                        idPaymentType: studentDebtData.idPaymentType,
                        idStudentDebt: studentDebtData.id,
                        month: (currentDate.getMonth() + 1).toString(),
                        year: currentDate.getFullYear().toString(),
                        description: studentDebtData.description,
                        idBankEntity: processModel?.idSchoolBankConfig,
                        entity: String(schoolBankConfigsData?.items.find(i => i.id === processModel?.idSchoolBankConfig)?.bankEntity)
                    });
                    if (referenceCode) {
                        const paymentReference: PaymentReferenceType = {
                            idStudent: studentDebtData.idStudent,
                            idPaymentType: studentDebtData.idPaymentType,
                            amount: studentDebtData.currentAmount,
                            dueDate: new Date(studentDebtData.dueDate).toISOString(),
                            referenceCode: referenceCode,
                            idStudentDebt: studentDebtData.id,
                            entity: String(schoolBankConfigsData?.items.find(i => i.id === processModel?.idSchoolBankConfig)?.bankEntity),
                            idBankEntity: String(schoolBankConfigsData?.items.find(i => i.id === processModel?.idSchoolBankConfig)?.id)
                        }
                        await mutationSaveReferenceCode.mutateAsync(paymentReference)
                        payment.entity = paymentReference.entity;
                        payment.reference = paymentReference.referenceCode!;
                        payment.totalPrice = paymentReference.amount;
                        payment.idStudentDebt = studentDebtData.id!;
                        payment.bankName = String(schoolBankConfigsData?.items.find(i => i.id === processModel?.idSchoolBankConfig)?.bankName || '');
                        payment.isPaymentByEntityReference = true;

                    }
                }

            }
            const data: any = {
                type: "STUDENT_PROCESS",
                outputFormat: "DOCX",
                data: {
                    ies: IES.NAME,
                    ano_lectivo: currentYear?.year,
                    nome_completo: _studentData?.fullname,
                    codigo: _studentData?.schoolCode,
                    curso: _studentData.course,
                    data_emissao: new Date().toLocaleDateString(),
                    cargo: loginData?.Role,
                    utilizador: userData?.Fullname ?? "",
                    delegacao: IES.ENROLLMENT_DEPARTAMENT_NAME
                },
                logoBase64: logoBase64 ?? '',
            };
            if (payment.isPaymentByEntityReference) {
                data.type = "STUDENT_PROCESS_REFERENCE";
                data.data.valor = payment?.totalPrice ?? 0;
                data.data.referencia = payment?.reference ?? "";
                data.data.banco = payment?.bankName ?? "";
                data.data.entidade = payment?.entity ?? "";
            }
            await exportDocument(data, "STUDENT_PROCESS");
        } catch (error) {
            toast.error("Erro ao renovar matrícula.");
        }
        finally {
            dispatch(setLoaderAvailable(false));
        }
    }
    return (
        <>
            <Lists
                status={status}
                TableComponent={() =>
                    <TableComponent
                        columns={Object.keys(columnNamesMap)}
                        items={
                            data?.items.map((e => {
                                return {
                                    ...e,
                                    isValidatedIcon: e.isValidated ? (
                                        <Badge color="green">Válido</Badge>
                                    ) : (
                                        <Badge color="gray">Pendente de validação</Badge>
                                    ),
                                }
                            }))}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange}
                        pageSize={pageSize}
                        onPageSizeChange={handlePageSizeChange}
                        onSearch={handleSearch}
                        search={searchTerm}
                        totalItems={data?.totalItems || 0}
                    />
                }
                handleClickCreate={handleClickCreate}
                handleClickCreateText={`Renovar matricula para o ano ${currentYear?.year}`}
            />
        </>
    );
}